import * as React from "react";
const SvgUpvoteStroke = (props) => /* @__PURE__ */ React.createElement("svg", { width: 21, height: 21, viewBox: "0 0 21 21", fill: "none", id: "svg1", xmlns: "http://www.w3.org/2000/svg", "xmlns:svg": "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("defs", { id: "defs1" }), /* @__PURE__ */ React.createElement("path", { style: {
  display: "inline",
  opacity: 1,
  fill: "inherit",
  fillOpacity: 1,
  stroke: "#f99c55",
  strokeWidth: 1.8,
  strokeLinecap: "round",
  strokeLinejoin: "miter",
  strokeDasharray: "none",
  strokeOpacity: 1
}, d: "M 10.5,18.412181 H 7.9575693 c -0.041858,0 -0.075692,-0.03412 -0.075339,-0.07598 l 0.058849,-6.973598 -4.4490839,0.02928 c -0.028411,1.87e-4 -0.044208,-0.03279 -0.026258,-0.05481 L 10.5,2.7067989 m 0,15.7053821 h 2.542431 c 0.04186,0 0.07569,-0.03412 0.07534,-0.07598 l -0.05885,-6.973598 4.449083,0.02928 c 0.02841,1.87e-4 0.04421,-0.03279 0.02626,-0.05481 L 10.5,2.7067989", id: "path27" }));
export default SvgUpvoteStroke;
